import React from 'react';
import { CirclePicker, CirclePickerProps } from 'react-color';

export default function ColourPicker(props: CirclePickerProps) {

  return <CirclePicker {...props} />;
}